<template>
  <el-dialog title="检查推荐点距离" :visible.sync="visible" width="960px" :close-on-click-modal="false" append-to-body
    @closed="onClosed">
    <div class="check-toolbar">
      <span class="label">路线：</span>
      <span class="value">{{ queryParam.pathId | pathNameTransfer }}</span>
      <span class="label">区域侧：</span>
      <span class="value">{{ formatIsStart(queryParam.isStart) }}</span>
      <span class="label">区域类型：</span>
      <span class="value">{{ queryParam.areaType | enumTransfer(areaTypeOpts, "value", "label") }}</span>
    </div>

    <div class="check-toolbar row2">
      <span class="label">最大距离(米)：</span>
      <el-input-number v-model="maxDistanceMeters" :min="1" :max="5000" :step="50" :size="size"
        controls-position="right" style="width: 160px" />
      <el-button type="primary" :size="size" :loading="loading" style="margin-left: 12px" @click="load">
        开始检查
      </el-button>
      <span v-if="summaryText" class="meta">{{ summaryText }}</span>
    </div>

    <el-table v-loading="loading" :data="tableRows" stripe border :size="size" max-height="480" empty-text="暂无超距推荐点">
      <el-table-column type="index" label="#" width="48" align="center" fixed />
      <el-table-column prop="areaName" label="区域名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="pointName" label="推荐点名称" min-width="140" show-overflow-tooltip />
      <el-table-column label="距区域边界(米)" width="130" align="right" sortable :sort-method="sortByDistance">
        <template slot-scope="scope">
          <span v-if="scope.row.distanceMeters != null">{{ scope.row.distanceMeters }}</span>
          <span v-else class="warn-text">{{ scope.row.reason || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="经纬度" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ formatLatLng(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="areaSettingId" label="区域ID" min-width="120" show-overflow-tooltip />
      <el-table-column prop="pointId" label="推荐点ID" min-width="120" show-overflow-tooltip />
    </el-table>

    <span slot="footer">
      <el-button type="warning" :size="size" :disabled="!hasInvalidAreas" @click="showOnMap">
        展示推荐区域
      </el-button>
      <el-button :size="size" @click="visible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { checkRecPointDistance } from "@/api";

export default {
  name: "RecPointCheckDialog",

  data() {
    return {
      visible: false,
      loading: false,
      maxDistanceMeters: 300,
      queryParam: {
        pathId: null,
        isStart: true,
        areaType: null
      },
      checkResult: null,
      tableRows: []
    };
  },

  computed: {
    ...mapState({
      size: (state) => state.btnSize,
      areaTypeOpts: (state) => state.enumMap["AREA_TYPE"] || []
    }),
    summaryText() {
      if (!this.checkResult) {
        return "";
      }
      const { checkedAreaCount, invalidAreaCount, maxDistanceMeters } = this.checkResult;
      return `已检查 ${checkedAreaCount || 0} 个区域，${invalidAreaCount || 0} 个区域存在超过 ${maxDistanceMeters} 米的推荐点，共 ${this.tableRows.length} 条`;
    },
    hasInvalidAreas() {
      return !!(this.checkResult && this.checkResult.invalidAreas && this.checkResult.invalidAreas.length);
    }
  },

  methods: {
    show(param) {
      const { pathId, isStart, areaType } = param || {};
      if (pathId == null || isStart == null || areaType == null) {
        this.$message.warning("请先选择路线和区域侧后再检查");
        return;
      }
      this.queryParam = {
        pathId,
        isStart,
        areaType
      };
      this.maxDistanceMeters = 300;
      this.checkResult = null;
      this.tableRows = [];
      this.visible = true;
    },

    onClosed() {
      this.checkResult = null;
      this.tableRows = [];
      this.loading = false;
    },

    load() {
      if (this.queryParam.pathId == null || this.queryParam.isStart == null || this.queryParam.areaType == null) {
        this.$message.warning("请先选择路线和区域侧后再检查");
        return;
      }
      this.loading = true;
      checkRecPointDistance({
        pathId: this.queryParam.pathId,
        isStart: this.queryParam.isStart,
        areaType: this.queryParam.areaType,
        maxDistanceMeters: this.maxDistanceMeters
      })
        .then((res) => {
          this.checkResult = res.data || {};
          this.tableRows = this.flattenInvalidAreas(this.checkResult.invalidAreas || []);
          if (!this.tableRows.length) {
            this.$message.success("未发现超过距离阈值的推荐点");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    flattenInvalidAreas(invalidAreas) {
      const rows = [];
      (invalidAreas || []).forEach((area) => {
        (area.invalidPoints || []).forEach((point) => {
          rows.push({
            areaSettingId: area.areaSettingId,
            areaName: area.areaName,
            pointId: point.pointId,
            pointName: point.pointName,
            lat: point.lat,
            lng: point.lng,
            distanceMeters: point.distanceMeters,
            reason: point.reason
          });
        });
      });
      return rows.sort((a, b) => (Number(b.distanceMeters) || 0) - (Number(a.distanceMeters) || 0));
    },

    sortByDistance(a, b) {
      return (Number(a.distanceMeters) || 0) - (Number(b.distanceMeters) || 0);
    },

    formatIsStart(v) {
      if (v === true) return "起点";
      if (v === false) return "终点";
      return "-";
    },

    formatLatLng(row) {
      const { lat, lng } = row || {};
      if (lat == null && lng == null) return "-";
      return `${lat || "-"}, ${lng || "-"}`;
    },

    showOnMap() {
      if (!this.hasInvalidAreas) {
        this.$message.warning("暂无需要展示的区域，请先执行检查");
        return;
      }
      this.$emit("show-on-map", this.checkResult.invalidAreas);
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="less">
.check-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;

  &.row2 {
    margin-bottom: 12px;
  }

  .label {
    margin-right: 4px;
    color: #606266;
    font-size: 14px;
    flex-shrink: 0;
  }

  .value {
    margin-right: 16px;
    color: #303133;
    font-size: 14px;
  }

  .meta {
    margin-left: 12px;
    color: #909399;
    font-size: 13px;
  }
}

.warn-text {
  color: #e6a23c;
}
</style>
